import {pageInfo, initPage,exportData,initPlanAdd, editSubmitData, saveTruckData,saveDriverData,uploadUrl, orderBasicDetailsInfo, fileDownload} from './../api';
import {findDriversByCarrierNo, findTrucksByCarrierNo, getCarrierCode,selectOrderStatus} from "../../../../api";
const loadingPlan = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    initPlanObj: null,
    initCarrierObj: null,
    initTruckObj: null,
    initDriverObj: null,
    submitObj: null,
    saveTruckObj: null,
    saveDriverObj: null,
    uploadUrlObj: null,
    orderStatusObj: null,
    orderBasicInfoObj: null,
    fileObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_PLAN_UPDATE(state,data) {
      state.initPlanObj = data || {};
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    INIT_CARRIER(state, data) {
      state.initCarrierObj = data.obj;
    },
    INIT_TRUCK(state, data) {
      state.initTruckObj = data.obj;
    },
    INIT_DRIVER(state, data) {
      state.initDriverObj = data.obj;
    },
    EDIT_SUBMIT_DATA(state, data) {
      state.submitObj = data;
    },
    SAVE_TRUCK_DATA(state, data) {
      state.saveTruckObj = data || {};
    },
    SAVE_DRIVER_DATA(state, data) {
      state.saveDriverObj = data || {};
    },
    UPLOAD_URL_DATA(state, data){
      state.uploadUrlObj = data || '';
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //初始化修改事件
    async initPlanAdd({commit}, obj){
      let resp = await initPlanAdd(obj);
      commit('INIT_PLAN_UPDATE', resp);
    },
    //初始化运输商
    async initCarrierData({ commit }, obj) {
      let resp = await getCarrierCode(obj);
      commit('INIT_CARRIER', resp);
    },
    //车辆列表
    async initTruckData({ commit }, obj) {
      let resp = await findTrucksByCarrierNo(obj);
      commit('INIT_TRUCK', resp);
    },
    //司机列表
    async initDriverData({ commit }, obj) {
      let resp = await findDriversByCarrierNo(obj);
      commit('INIT_DRIVER', resp);
    },
    //提交
    async editSubmitData({ commit }, obj) {
      let resp = await editSubmitData(obj);
      commit('EDIT_SUBMIT_DATA', resp);
    },
    //新增车辆
    async saveTruckData({commit}, obj){
      let resp = await saveTruckData(obj);
      commit('SAVE_TRUCK_DATA', resp);
    },
    //新增司机事件
    async saveDriverData({commit}, obj){
      let resp = await saveDriverData(obj);
      commit('SAVE_DRIVER_DATA', resp);
    },
     //文件上传路径
     async uploadUrl({ commit }, obj) {
      let resp = await uploadUrl(obj);
      commit('UPLOAD_URL_DATA', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
  }
}
export default loadingPlan



// WEBPACK FOOTER //
// ./src/page/transport/loadingPlan/store/loadingPlan.store.js